import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { text } from 'styles-js/mixins/typography';
export const Disclaimer = () => <Container data-sentry-element="Container" data-sentry-component="Disclaimer" data-sentry-source-file="disclaimer.tsx">
    <p>
      {i18n.t('Content on HealthUnlocked does not replace the relationship between you and doctors or other healthcare professionals nor the advice you receive from them.')}
    </p>
    <p>
      {i18n.t('Never delay seeking advice or dialling emergency services because of something that you have read on HealthUnlocked.')}
    </p>
  </Container>;
const Container = styled.div`
  ${text};
  background-color: ${({
  theme
}) => theme.colorGreenLighter};
  border-radius: 4px;
  padding: 20px;

  p + p {
    margin-top: 12px;
  }
`;